<template>
  <content-container :table-row-count="tableData.length">
    <div>
      <el-button class="mb-[20px]" type="primary" @click="toAdd">
        <svg-icon icon="lucide:circle-plus" />新增
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table ref="tableRef" v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle">
      <el-table-column align="center" type="selection" :min-width="55" />
      <el-table-column align="center" type="index" label="序号" :min-width="80" />
      <el-table-column align="center" prop="bankName" label="来账银行名称" :min-width="220" show-overflow-tooltip />
      <el-table-column align="center" prop="bankAccount" label="来账银行账号" :min-width="220" />
      <el-table-column align="center" prop="accountStatusText" label="状态" :min-width="140">
        <template #default="scope">
          <el-tag :type="alipayBankReportStatusStyle[scope.row.accountStatus]">
            {{ scope.row.accountStatusText }}
          </el-tag>
          <el-tooltip v-if="scope.row.accountStatus === EAlipayBankReportStatus.REJECT" :content="scope.row.rejectReason" placement="top">
            <svg-icon class="!w-[16px] !h-[16px] ml-1 main-primary-text " style="vertical-align: -0.25rem;" icon="lucide:info" />
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="remark" label="备注" :min-width="220" show-overflow-tooltip />

      <el-table-column align="center" prop="createTime" label="创建时间" :min-width="220" />
      <el-table-column
        v-if="buttons.length > 0"
        align="center"
        prop="actions"
        fixed="right"
        label="操作"
      >
        <template #default="scope">
          <table-row-buttons :buttons="buttons" :row="scope.row" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>

    <add-acount ref="addAcountRef" :server-id="serverId" :visible="showAddAcount" :type="isEdit ? 'edit' : 'add'" :row="currentRow" @close="showAddAcount = false" @confirm="confirmAddAcount" />
  </content-container>
</template>

<script setup lang="ts">
import AddAcount from '@core/main/src/modules/alipay/dialogs/AddAcount.vue';
import { computed, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import { initOperatorColumnStyle, onConfirm, SvgIcon, TableRowButtons } from '@vue3/components';
import {
  ContentContainer,
  useTblPermissionButtons,
  queryAlipayUnitBankAccountPage,
  deleteUnitBankAccount,
} from '@core/main';
import { alipayBankReportStatusStyle, EAlipayBankReportStatus } from '@core/main/types';

defineOptions({ name: 'AlipayIncomingAccount' });

const defaultPageSize = 12;
const route = useRoute();
const params = reactive<any>({
  page: 1,
  size: defaultPageSize,
});

const loading = ref(false);
const showAddAcount = ref(false);
const isEdit = ref(false);
const total = ref(0);

const currentRow = ref<any>({});
const tableData = ref<any[]>([]);
const tableRef = ref<any>(null);
const serverId = computed(() => route.query.serverId || null) as any;
const { buttons } = useTblPermissionButtons([
  {
    name: '重新报备',
    relationField: 'accountStatus',
    relationValue: EAlipayBankReportStatus.REJECT,
    action: tochangeAction,
  },

  {
    name: '删除',
    relationField: 'accountStatus',
    relationValue: EAlipayBankReportStatus.REJECT,
    action: deleteAction,
  },
]);

function toAdd() {
  isEdit.value = false;
  showAddAcount.value = true;
}

function tochangeAction(row) {
  isEdit.value = true;
  currentRow.value = JSON.parse(JSON.stringify(row));
  showAddAcount.value = true;
}

function deleteAction(row) {
  currentRow.value = row;

  onConfirm({
    message: '确认要删除吗？',
    onOk: async () => {
      try {
        await deleteUnitBankAccount({ id: row.id });
        ElMessage.success('删除成功');
        doSearch();
      } catch (error) {
        if ((error as Error).message) ElMessage.error((error as Error).message);
      }
    },
  });
}

async function fetchData() {
  loading.value = true;
  try {
    const res = await queryAlipayUnitBankAccountPage({
      ...params,
      serverId: serverId.value,
    });

    tableData.value = res.data;
    total.value = res.total;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

function doSearch() {
  params.page = 1;
  fetchData();
}

function confirmAddAcount() {
  showAddAcount.value = false;
  fetchData();
}

fetchData();
</script>
